export default "__VITE_ASSET__C4EcVSkq__"